// extracted by mini-css-extract-plugin
export default {"unitPrice":"Products_unitPrice__1ijpg"};